export default "__VITE_ASSET__6228ff27__"